import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const PlayButtonContainer = styled(Stack)`
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;
